import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const StyTitle = styled(Typography, {
    name: 'StyTitle',
})(({ theme }) => ({
    color: theme.palette.primary.main,
    fontWeight: 600,
}));

export const StyVerticalLayout = styled('div', {
    name: 'StyLayout',
})<{ size?: number }>(({ size }) => ({
    display: 'flex',
    flex: size || 1,
    flexDirection: 'column',
}));

export const StyHeader = styled('div', {
    name: 'StyLayout',
})({
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minHeight: '40px',
});

export const StyLayout = styled('div', {
    name: 'StyLayout',
})({
    display: 'flex',
    flex: 1,
    minHeight: '350px',
});
